<p>street-building-payment-item works!</p>
